export default "__VITE_ASSET__32a2abdc__"